

import request from '@/utils/request';



export const alterPassword = (row) => {
	return request({
	  url: '/proFileApi/customer/update/password',
	  method: 'post',
	  data: row,
	  
	})
  }


  export const alterUserName = (row) => {
	return request({
	  url: '/proFileApi/customer/update',
	  method: 'post',
	  data: row,
	  
	})
  }

  
  export const fetchCustomerInfo = (query) => {
	return request({
		url: '/proFileApi/customer/detail',
		method: 'get',
		params: query,
		
	})
}